import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IObjectsControllable, ILinkedPageObjectSpecifiable } from "../../../../documaker/domain/format/objects";

export interface IScriptExecuteTriggerBehaviorPropertyEditable {
  scriptExecuteTriggerBehavior(): IPropertyEditable<IObjectsControllable<ILinkedPageObjectSpecifiable>>;
}

export function instanceOfIScriptExecuteTriggerBehaviorPropertyEditable(instance: any): instance is IScriptExecuteTriggerBehaviorPropertyEditable {
  return instance
      && instance.scriptExecuteTriggerBehavior
      && instanceOfIPropertyEditable<IObjectsControllable<ILinkedPageObjectSpecifiable>>(instance.scriptExecuteTriggerBehavior());
}
